// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/mind-body-low-battery.svg';

export const MindBodyLowBattery = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
